import { render, staticRenderFns } from "./InstitutionInfo.vue?vue&type=template&id=b6877308&"
import script from "./InstitutionInfo.vue?vue&type=script&lang=ts&"
export * from "./InstitutionInfo.vue?vue&type=script&lang=ts&"
import style0 from "./InstitutionInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports